<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Listado de Cargos">
          <b-form>
            <b-form-group
              label="Buscar"
              label-for="nombreBusqueda"
              :label-cols="1"
              horizontal>
              <b-form-input id="nombreBusqueda" 
                v-model= "nombreBusqueda" 
                type="text">
              </b-form-input>
            </b-form-group>
          </b-form>

          <b-table class="registro" responsive="sm" 
              :items="cargos" 
              :fields="cargosFields" 
              :filter="nombreBusqueda"
              :current-page="paginaActual"
              :per-page="registrosPorPagina"
              @filtered="onFiltered"
              @row-clicked="consultar"
              :busy="tableBusy">
            <div slot="table-busy" class="text-center">
              <b-spinner variant="primary" label="Spinning" />
            </div>              
            <template v-slot:cell(inactivo)="data">
              {{ (data.item.inactivo) ? "Si" : "No" }}
            </template>
            <template v-slot:cell(opciones)="data" v-if="accesoABM">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos del Cargo</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
      </b-col>
    </b-row>
    <div class="fixed-btn" v-if= 'accesoABM'>
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'cargos/getField',
  mutationType: 'cargos/updateField',
});

export default {
  name: 'Cargos',
  components: {
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data: () => {
    return {
      cargosFields: [
        {
          key: 'nombre',
          sortable: true
        },
        { key: 'inactivo' },
        {
          key: 'opciones',
          label: '',
        },
      ],

      tableBusy: false,

      filtro: {
        nombre: '',
        incluirInactivos: false,
      },

      accesoABM: true,
      accesoDatos: true,
    }
  },
  computed: {
    ...mapFields([
      'cargos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'nombreBusqueda'
    ]),
  },
  created() {
    this.getItems();
  },  
  methods: {
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('cargos/getCargos')
        .then(() => this.tableBusy = false)
        .catch( error => this.showErrorMsj (error));

    },
    consultar (item) {
      if (this.accesoDatos) {
        this.$router.push({ name: 'CargoDatos', 
                            params: { id: item.id }});
      }
    },
    editar (item) {
      this.$router.push({ name: 'CargoABM', 
                          params: { id: item.id }});
    },
    agregar () {
      this.$router.push({ name: 'CargoABM', 
                          params: { id: 0 }});
    },
    onFiltered(filteredItems) {
      this.totalRegistros = filteredItems.length
      this.paginaActual = 1
    },
  },
  watch: {
  }    
}
</script>

<style>
</style>
